import MaterialPaper from "../../../../__snowpack__/pkg/@mui/material/Paper.js";
import styled from "styled-components";
export const UnitsMergedContainer = styled(MaterialPaper).withConfig({
  displayName: "merge-suggestion-itemstyles__UnitsMergedContainer",
  componentId: "sc-bl7ybr-0"
})(["", ""], {
  "--tw-bg-opacity": "1",
  backgroundColor: "rgba(255, 255, 255, var(--tw-bg-opacity))",
  padding: "0.5rem"
});
